import { api } from './api-client';
export class AuthService {
    async login(email, password, tenantId) {
        const response = await api.post('/auth/login', {
            email,
            password,
            tenantId,
        });
        api.setToken(response.accessToken);
        return response;
    }
    async getProfile() {
        return api.get('/auth/me');
    }
    logout() {
        api.clearToken();
    }
    isAuthenticated() {
        return api.hasToken();
    }
}
export const authService = new AuthService();
